export interface ApiImageToTextResponse {
    techDesc: string
}

export const Image2Text = Symbol('Image2Text');

export interface Image2Text {
    image2text(taskId: string, desc: string, data: any): Promise<string>
}

export const GetSemanticId = Symbol('GetSemanticId');

export interface ApiGetSemanticIdRequest {
    taskId: string,
    query: string
    ipc_logic_type: 'AND'
}

export interface ApiGetSemanticIdResponse {
    url: string
}

export interface GetSemanticId {
    getSemanticId(
        data: ApiGetSemanticIdRequest
    ): Promise<ApiGetSemanticIdResponse>
}
